import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const SortIcon = styled.span`
    margin-left: 10px;
`;

export const EAIcon = styled.span`
    width: 26px;
    height: 19px;
    border-radius: 10px;
    opacity: 1;
    background: #ebebeb 0% 0% no-repeat padding-box;
    text-align: center;
    color: #140f4b;
    font-size: 11px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.09px;
    margin-left: 12px;
`;

export const HeaderGridContainer = styled(Grid)`
    width: 1096px;
    height: 48px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    margin-top: 24px;
    padding: 10px 15px;
    ${media.mobileDevice`
        display:none !important;
    `}
`;

export const HeaderGridMobileContainer = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    
    
    width: auto;
        height: 48px;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 2px #00000029;
        border: 1px solid #DCDCDC;
        border-radius: 6px 6px 0px 0px;
        opacity: 1;
        margin-top: 18px;
        padding: ${({ mbHeaderPadding }) =>
            mbHeaderPadding ? mbHeaderPadding : '10px 15px'};
    `}
`;

export const HeaderTextMobileContainer = styled(Grid)`
    display: none;
    ${media.mobileDevice` 
    
    display: flex;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;   
    height: 22px;
    text-align: left;
    letter-spacing: 0px;
    color: #3C3C3C;
    opacity: 1;
    
    `}
`;

export const ItemCardTextMobileContainer = styled(Grid)`
    display: none;
    ${media.mobileDevice` 
    padding-top: ${({ mbPaddingTop }) =>
        mbPaddingTop ? mbPaddingTop : '10px'};
    padding-left: 0px;
    display: flex;
    height: ${({ mbHeight }) => (mbHeight ? mbHeight : '22px')};
    text-align: left;
    letter-spacing: 0px;
    opacity: 1 !important;
    margin-left: -8px;
    `}
`;
export const HeaderTextContainer = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    letter-spacing: 0px;
    padding-left: 0px;
    color: #3c3c3c;
    opacity: 0.7;
    height: 48px;

    &.text-align-right {
        text-align: right;
    }
    &.nowrap-text-responsive {
        white-space: nowrap;
        text-align: right;
    }
    &.ItemDetailsHeader {
        ${media.smalDevice`
            padding-left: 20px;
        `}
        ${media.mobileDevice`
        `}
    }
`;

export const ItemCardTextContainer = styled(Grid)`
    letter-spacing: 0px;
    padding-left: 0px;
    &.DescGrid {
        ${media.smalDevice`
            padding-left: 20px;
        `}
        ${media.mobileDevice`
        `}
    }
`;

export const GridContainer = styled(Grid)`
    width: 1096px;
    padding: 10px 15px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    opacity: 1;
    margin-top: 10px;
    ${media.mobileDevice`
        display:none !important;
    `}
`;

export const GridMobileContainer = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    padding-top: 7px;
    padding-left: 20px;

    width: auto !important;
        height:  ${({ mbHeight }) => (mbHeight ? mbHeight : '178px')};
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #00000029;
        border-radius: 6px;
        margin: 10px 2px 0px 2px; 
    `}
`;

export const ItemDetailText = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi, isItalic }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi
            ? 'AvenirNextWorld Demi'
            : isItalic && 'AvenirNextWorld italic'};
    font-size: ${({ isDemi }) => (isDemi ? '16px' : '13px')};
    color: ${({ isRegular, isDemi }) =>
        isRegular ? '#000000' : isDemi && '#140F4B'};
    opacity: ${({ isRegular, isDemi }) => (isRegular ? '1' : isDemi && '1')};
    letter-spacing: ${({ isRegular, isDemi }) =>
        isRegular ? '-0.1px' : isDemi && '-0.13px'};
    ${media.mobileDevice`
        font-size: ${({ isDemi }) => (isDemi ? '16px' : '12px')};
    `}
`;

export const QunatityText = styled.div`
    text-align: center;
    font-family: 'AvenirNextWorld Regular';
    font-size: 16px;
    color: #202124;
    opacity: 0.5;
    letter-spacing: 0px;
    ${media.mobileDevice`
       
    `}
`;

export const OnHandText = styled.div`
    display: flex;
    margin-left: ${({ marginLeft }) => marginLeft};
    flex-direction: row-reverse;
`;

export const LoTtext = styled.span`
    text-align: right;
    font-size: 13px;
    color: #000000;
    opacity: 1;
    letter-spacing: -0.1px;
    ${media.mobileDevice`
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 13px;
    color: #000000;
    opacity: 1;
    letter-spacing: -0.1px;
    `}
`;
export const UsedBytext = styled.span`
    text-align: right;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #cc0000;
    opacity: 1;
    letter-spacing: -0.1px;
    ${media.mobileDevice`
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 13px;
    color: #CC0000;
    opacity: 1;
    letter-spacing: -0.1px;
    margin-top: -1px;
    `}
`;

export const UseByDate = styled.span`
    text-align: right;
    font-family: 'AvenirNextWorld Regular';
    font-size: 13px;
    color: #cc0000;
    opacity: 1;
    letter-spacing: -0.1px;
    display: inherit;
    margin-top: -3px;
    ${media.mobileDevice`
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 13px;
    color: #CC0000;
    opacity: 1;
    letter-spacing: -0.1px;
    margin-top: -1px;
    `}
`;

export const InventoryContentWrapper = styled.div`
    overflow-y: scroll;
    overflow-x: hidden; 

    height: ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 360px - ${bannerHeight})`:'calc(100vh - 360px)'}
        };

    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 10px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        height: 7rem;
    }

    ${media.mediumDevice`
        height:  ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 390px - ${bannerHeight})`:'calc(100vh - 390px)'}
        }; 
    `}
    ${media.smalDevice`
        height: calc(100vh - 430px);
    `}
    ${media.mobileDevice`
        overflow-y: unset;
        overflow-x: unset;
        height: auto;
        padding-bottom: 240px;
    `}

    @media screen and (min-device-width: 1020px) and (max-device-width: 1030px) and (min-device-height: 1360px) and (max-device-height: 1370px) and (orientation: portrait) {  
        height:  ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 390px - ${bannerHeight})`:'calc(100vh - 390px)'}
        };
    }

    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1030px) and (orientation: landscape) {  
        height:   ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 390px - ${bannerHeight})`:'calc(100vh - 390px)'}
        };
    }

    @media screen and (min-width: 830px) and (max-width: 840px) and (orientation: portrait) {
        height:  ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 390px - ${bannerHeight})`:'calc(100vh - 390px)'}
        };
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {  
        height:   ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 420px - ${bannerHeight})`:'calc(100vh - 420px)'}
        };
    }

    @media screen and (min-device-width: 767px) and (max-device-width: 772px) and (min-device-height: 1020px) and (max-device-height: 1030px) and (orientation: portrait) {  
        height:   ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 390px - ${bannerHeight})`:'calc(100vh - 390px)'}
        };
    }

    @media screen and (min-device-width: 1020px) and (max-device-width: 1030px) and (min-device-height: 767px) and (max-device-height: 772px) and (orientation: landscape) {  
        height:   ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 390px - ${bannerHeight})`:'calc(100vh - 390px)'}
        };
    }

    @media only screen and (min-width: 1110px) and (max-width: 1122px) and (orientation: landscape) {
        height:   ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - 385px - ${bannerHeight})`:'calc(100vh - 385px)'}
        };
    }

    @media screen and (min-device-width: 325px) and (max-device-width: 500px) and (orientation: landscape) {  
        height:   ${({ bannerHeight }) =>
            bannerHeight ? `calc(100vh - ${bannerHeight})`:'calc(100vh - 10px)'}
        };
    }
`;

export const QtyValidationDiv = styled.div`
    top: 445px;
    left: 93px;
    width: 209px;
    height: 22px;
    font-size: 12px;
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #ed002a;
    opacity: 1;
`;

export const QtyValidationIcon = styled.div`
    top: 448px;
    left: 71px;
    width: 16px;
    height: 16px;
    background: #ed002a 0% 0% no-repeat padding-box;
    border: 0.6000000238418579px solid #ffffff;
    opacity: 1;
`;
export const MdiOptions = styled.span`
    width: 18px;
    height: 18px;
    margin-left: 4px;
    margin-top: 1px;
    background-image: url(${({ imageSrc }) => imageSrc && imageSrc});
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    margin-right: 2px;
    ${media.mobileDevice`
        margin-top: 1px;
        margin-left:  ${({ mbMarginLeft }) =>
            mbMarginLeft ? mbMarginLeft : '4px'};
        width: 16px;
        height: 16px;
    `}
`;

export const NTIconContainer = styled.div`
    width: 24px;
    height: 18px;
    border: 0.5px solid #0699bd;
    border-radius: 4px;
    opacity: 1;
    background: #c2f1fd 0% 0% no-repeat padding-box;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const NTIcon = styled.span`
    letter-spacing: 0px;
    color: #04667e;
    opacity: 0.99;
    text-align: left;
    font-size: 10px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
`;

export const TIconContainer = styled.div`
    width: 24px;
    height: 18px;
    background: #ffebbf 0% 0% no-repeat padding-box;
    border: 0.5px solid #ffad00;
    border-radius: 4px;
    opacity: 1;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TIcon = styled.span`
    text-align: left;
    font-size: 10px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
    color: #bf8300;
    opacity: 0.92;
`;

export const Alert = styled.span`
    text-align: left;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #ed002a;
    opacity: 1;
    margin-top: 10px;
    margin-left: -8px;
`;

export const MaxExpirytext = styled.span`
    text-align: right;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    color: #b75a09;
    opacity: 1;
    letter-spacing: -0.1px;
    ${media.mobileDevice`
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 13px;
    color: #B75A09;
    opacity: 1;
    letter-spacing: -0.1px;
    margin-top: -1px;
    `}
`;

export const MaxExpiryDate = styled.span`
    text-align: right;
    font-family: 'AvenirNextWorld Regular';
    font-size: 13px;
    color: #b75a09;
    opacity: 1;
    letter-spacing: -0.1px;
    display: inherit;
    margin-top: -3px;
    ${media.mobileDevice`
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: 13px;
    color: #B75A09;
    opacity: 1;
    letter-spacing: -0.1px;
    margin-top: -1px;
    `}
`;
